/* Cart Drawer — Recommendations Slider (nav only, Liquid-driven filtering) */
(() => {
  const FLAG = 'smRecoInit';

  function bindNav(root) {
    const wrapper = root.querySelector('.sm-cart-reco__track-wrapper');
    const list    = root.querySelector('.sm-cart-reco__list');
    const prev    = root.querySelector('.sm-cart-reco__nav--prev');
    const next    = root.querySelector('.sm-cart-reco__nav--next');

    if (!wrapper || !list || !prev || !next) return;

    const getStep = () => {
      const item = list.querySelector('.sm-cart-reco__item');
      return item ? item.offsetWidth + 8 : 220;
    };

    const updateNavState = () => {
      const maxScroll = wrapper.scrollWidth - wrapper.clientWidth - 1;
      prev.disabled = wrapper.scrollLeft <= 0;
      next.disabled = wrapper.scrollLeft >= maxScroll;
    };

    const scrollByDir = (dir) => {
      const step = getStep();
      wrapper.scrollBy({ left: dir * step, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByDir(-1));
    next.addEventListener('click', () => scrollByDir(1));
    wrapper.addEventListener('scroll', updateNavState);

    updateNavState();
  }

  function initOne(section) {
    if (!section) return;
    if (section.dataset[FLAG] === '1') return;

    const root = section.querySelector('[data-sm-cart-reco]');
    if (!root) return;

    section.dataset[FLAG] = '1';
    bindNav(root);
  }

  function initAll() {
    document
      .querySelectorAll('#CartDrawerReco')
      .forEach((section) => initOne(section));
  }

  function observeDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const mo = new MutationObserver(() => {
      initAll();
    });

    mo.observe(drawer, { childList: true, subtree: true });
  }

  // ── Cart-empty class corrigeren na ATC vanuit reco of elders.
  // Bug: ergens (mogelijk Loess re-render) wordt class="is-empty" weer toegevoegd
  // op loess-cart-drawer-items terwijl de cart wel items heeft → cart-empty UI flikkert.
  // Fix: na elke cart:updated event én na MutationObserver-trigger van class
  // op loess-cart-drawer-items: synchroniseer met de actuele cart.item_count.
  function syncEmptyClass() {
    const drawerItems = document.querySelector('loess-cart-drawer-items');
    if (!drawerItems) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        const nonGoodieCount = (cart.items || [])
          .filter((i) => !(i.properties && i.properties._goodie === 'true'))
          .length;
        const shouldBeEmpty = nonGoodieCount === 0;
        if (drawerItems.classList.contains('is-empty') !== shouldBeEmpty) {
          drawerItems.classList.toggle('is-empty', shouldBeEmpty);
        }
        document.querySelectorAll('[data-cart-empty-toggle]').forEach((el) => {
          el.classList.toggle('is-cart-empty', shouldBeEmpty);
        });
        syncShippingBar(cart);
      })
      .catch(() => {});
  }

  // Defensieve sync van de tier-bar: verwijdert/voegt is-*-reached classes toe
  // op basis van actuele cart.total_price, ongeacht of de Liquid section
  // (her)gerenderd is. Voorkomt "stale" reached-classes als de section niet
  // tijdig opnieuw rendert na ATC of cart-clear.
  //
  // Markup (nieuwe versie):
  //   #CartShippingBar.aps-tier-bar
  //     .aps-tier-bar__fill
  //     .aps-tier-bar__pin--ship / __pin--gift
  //     .aps-tier-bar__label--ship / __label--gift
  function syncShippingBar(cart) {
    const bar = document.getElementById('CartShippingBar');
    if (!bar) return;
    const total = (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;
    const shipThreshold = parseInt(bar.dataset.shipCents || '3500', 10);
    const giftThreshold = parseInt(bar.dataset.giftCents || '5000', 10);
    const barMax = Math.max(shipThreshold, giftThreshold);
    const pct = Math.min(100, Math.round((total / barMax) * 100));

    const shipReached = total >= shipThreshold;
    const giftReached = total >= giftThreshold;
    const allReached = shipReached && giftReached;

    bar.classList.toggle('is-ship-reached', shipReached);
    bar.classList.toggle('is-gift-reached', giftReached);
    bar.classList.toggle('is-all-reached', allReached);

    const fill = bar.querySelector('.aps-tier-bar__fill');
    if (fill) fill.style.width = pct + '%';

    bar.querySelectorAll('.aps-tier-bar__pin--ship, .aps-tier-bar__label--ship').forEach((el) => {
      el.classList.toggle('is-reached', shipReached);
    });
    bar.querySelectorAll('.aps-tier-bar__pin--gift, .aps-tier-bar__label--gift').forEach((el) => {
      el.classList.toggle('is-reached', giftReached);
    });

    // Gift-tile mag niet floating zijn als beide tiers bereikt zijn
    const drawer = document.getElementById('CartDrawer');
    const cartItems = document.querySelector('loess-cart-drawer-items');
    if (drawer) drawer.classList.toggle('is-all-reached', allReached);
    if (cartItems) cartItems.classList.toggle('is-all-reached', allReached);
  }

  function watchEmptyState() {
    document.documentElement.addEventListener('cart:updated', () => {
      // Direct + na korte delay (om Loess' interne re-render te overrulen).
      syncEmptyClass();
      setTimeout(syncEmptyClass, 150);
      setTimeout(syncEmptyClass, 500);
    });
    // MutationObserver: als ergens is-empty wordt teruggezet zonder cart-update
    const drawerItems = document.querySelector('loess-cart-drawer-items');
    if (drawerItems) {
      const mo = new MutationObserver((muts) => {
        for (const m of muts) {
          if (m.attributeName === 'class') {
            syncEmptyClass();
            break;
          }
        }
      });
      mo.observe(drawerItems, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // ── Gift-tile × close → Loess-style sections fetch (zelfde flow als
  // loess-cart-remove-button gebruikt). Daardoor wordt de drawer correct
  // gerenderd zonder volledige page-reload.
  function bindGiftRemove() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-aps-gift-remove]');
      if (!btn) return;
      e.preventDefault();
      const key = btn.dataset.lineKey;
      if (!key) return;
      btn.disabled = true;

      const cartItems = document.querySelector('loess-cart-drawer-items');
      const sections = cartItems && typeof cartItems.getSectionsToRender === 'function'
        ? cartItems.getSectionsToRender().filter(s => s && s.section).map(s => s.section)
        : ['cart-drawer-items', 'cart-drawer-recommendations', 'cart-total-price', 'header-cart-icon'];

      const body = JSON.stringify({
        id: key,
        quantity: 0,
        sections: sections,
        sections_url: window.location.pathname,
      });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: body,
        credentials: 'same-origin',
      })
        .then((r) => (r.ok ? r.json() : Promise.reject(r)))
        .then((state) => {
          if (cartItems && typeof cartItems.renderCartItems === 'function') {
            cartItems.renderCartItems(state);
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: state } }));
          }
          // Loess section-render vervangt alleen .cart-items (de table). De
          // aps-gift-tile staat als sibling boven de table en moet handmatig
          // weg uit de DOM.
          document
            .querySelectorAll('.aps-gift-tile[data-line-key="' + key + '"]')
            .forEach((el) => el.remove());
        })
        .catch(() => {
          btn.disabled = false;
        });
    });
  }

  // ── Loess remove-button heeft een listener met `{ once: true }`. Na de
  // eerste click is de e.preventDefault() weg en zou een tweede klik
  // (double-click of fast-tap) de native `<a href="/cart/change?...">` volgen
  // → redirect naar de /cart-page. Voorkom dit met een capture-listener
  // die alleen preventDefault doet (geen stopPropagation, anders blokkeren
  // we de Loess-listener). Werkt voor zowel eerste als tweede click.
  function preventLoessRemoveNavigation() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.addEventListener('click', (e) => {
      const a = e.target.closest('loess-cart-remove-button a');
      if (a) e.preventDefault();
    }, true);
  }

  // ── Override Loess getSectionsToRender voor de drawer-cart-items zodat de
  // hele #MainCartItems wordt ververst bij section-render (i.p.v. alleen
  // de .cart-items table). Daarmee wordt ook de aps-gift-tile (sibling van
  // de table) automatisch gerefreshed na ATC ≥€50 of cart-mutaties.
  function patchCartItemsSectionsToRender() {
    const tryPatch = () => {
      const el = document.querySelector('loess-cart-drawer-items');
      if (!el || el.__apsPatched || typeof el.getSectionsToRender !== 'function') return false;
      const orig = el.getSectionsToRender.bind(el);
      el.getSectionsToRender = function () {
        const list = orig();
        return list.map((s) => {
          if (s && s.id === 'MainCartItems') {
            return { ...s, selector: '#MainCartItems' };
          }
          return s;
        });
      };
      el.__apsPatched = true;
      return true;
    };
    if (tryPatch()) return;
    // Element nog niet gedefinieerd → wacht via observer
    const obs = new MutationObserver(() => {
      if (tryPatch()) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    initAll();
    observeDrawer();
    watchEmptyState();
    bindGiftRemove();
    preventLoessRemoveNavigation();
    patchCartItemsSectionsToRender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
